import { render, staticRenderFns } from "./SmOwLegend.vue?vue&type=template&id=7fe93d14&"
import script from "./SmOwLegend.vue?vue&type=script&lang=ts&"
export * from "./SmOwLegend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports